import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"
import image1803 from "./screenShot/screen-1803.png"
import image1818 from "./screenShot/screen-1818.png"
import image1820 from "./screenShot/screen-1820.png"
import image2003 from "./screenShot/screen-2003.png"
import image2005 from "./screenShot/screen-2005.png"
import image2006 from "./screenShot/screen-2006.png"
import image2020 from "./screenShot/screen-1820.png"
import imageBreak from "./screenShot/screen-B.png"
import imageEntrance from "./screenShot/screen-Entrance.png"
import imageLobby from "./screenShot/screen-Lobby.png"
import imageOut from "./screenShot/screen-Out.png"
import imageCoin from "./screenShot/screen-Coin.png"
import imageSmoke from "./screenShot/screen-Smoke.png"
import imageJido from "./screenShot/screen-Jido.png"
import image8F from "./screenShot/screen-8F.png"
import image10F from "./screenShot/screen-10F.png"

import SlideItem from "./SlideItem";

import MediaQuery from "react-responsive";

const Slide = (props) => {
    const {current, move1803S, move1818, move1820, move2003, move2005, move2006, move2020,
        moveBreak, moveCoin, moveEntrance, moveJido, moveLobby, moveOut, moveSmoke, move8F, move10F } = props;

    console.log(window.screen.width)
    
    const settings1 = {
        dots: false,
        infinite: false,
        arrow:true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4
    };

    const settings2 = {
        dots: false,
        infinite: false,
        arrow:true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2
    };

    const list = [{placeId:"1803", placeName:"1803Sシングル", img:"/static/media/screen-1803.c8db3cd12ad8815fc5f2.png", move:move1803S},
    {placeId:"1818", placeName:"1818シングル", img:"/static/media/screen-1818.119fc22f65c8997364b5.png", move:move1818},
    {placeId:"1820", placeName:"1818ダブル", img:"/static/media/screen-1820.7eb29b74d04b205f776e.png", move:move1820},
    {placeId:"2003S", placeName:"2003Sシングル", img:"/static/media/screen-2003.a17c8591805c692d5d05.png", move:move2003},
    {placeId:"2005", placeName:"2005シングル", img:"/static/media/screen-2005.4af914592f75856ddb9b.png", move:move2005},
    {placeId:"2006", placeName:"2006ツイン", img:"/static/media/screen-2006.00bc316ff939a827727b.png", move:move2006},
    {placeId:"2020", placeName:"2020ダブル", img:image2020, move:move2020},
    {placeId:"Break", placeName:"朝食会場", img:"/static/media/screen-B.facf9e626cc56d290be4.png", move:moveBreak},
    {placeId:"Entrance", placeName:"エントランス", img:"/static/media/screen-Entrance.4f26408fe988f873207f.png", move:moveEntrance},
    {placeId:"Lobby", placeName:"ロビー", img:"/static/media/screen-Lobby.b19ec037df7fc341e3d5.png", move:moveLobby},
    {placeId:"Out", placeName:"外観", img:"/static/media/screen-Out.b78d391984b2fd49e93f.png", move:moveOut},
    {placeId:"Coin", placeName:"コインランドリー", img:imageCoin, move:moveCoin},
    {placeId:"Jido", placeName:"8F自動販売機", img:"/static/media/screen-Jido.785f5b11a4326364b8d2.png", move:moveJido},
    {placeId:"Smoke", placeName:"1F喫煙所", img:"/static/media/screen-Smoke.f611f40314aeb8a76e85.png", move:moveSmoke},
    {placeId:"8F", placeName:"8F廊下", img:"/static/media/screen-8F.519481a0b1df774adcde.png", move:move8F},
    {placeId:"10F", placeName:"10F廊下", img:"/static/media/screen-10F.865e234079788b57fb8c.png", move:move10F},
    
    ]

    return(
        <div className="Slide-container">
            <MediaQuery minWidth={481}>
            <Slider {...settings1}>
            {list.map((data, index) => {
                return(
                    <SlideItem key={index} current={current} placeId={data.placeId} 
                    placeName={data.placeName} img={data.img} move={data.move}/>
                )
            })}
            </Slider>
            </MediaQuery>
            <MediaQuery maxWidth={480}>
            <Slider {...settings2}>
            {list.map((data, index) => {
                return(
                    <SlideItem key={index} current={current} placeId={data.placeId} 
                    placeName={data.placeName} img={data.img} move={data.move}/>
                )
            })}
            </Slider>
            </MediaQuery>
            
        </div>
    )
}
export default Slide